exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reparse-dependent-packages-button {\n  transition: background 0.3s, color 0.3s;\n}\n.reparse-dependent-packages-button.enabled {\n  background: #ffe2ad;\n  color: #000;\n  border: 0;\n}\n.reparse-dependent-packages-button.enabled:hover {\n  background: #ffc773;\n}\n", ""]);

// exports
